var FcSearchInputModule = /** @class */ (function () {
    function FcSearchInputModule() {
    }
    return FcSearchInputModule;
}());
export { FcSearchInputModule };
